import { jsx as _jsx } from "react/jsx-runtime";
const variantClasses = {
    cold: "bg-blue-100 text-blue-800",
    warm: "bg-yellow-100 text-yellow-800",
    hot: "bg-red-100 text-red-800",
    sold: "bg-green-100 text-green-800",
    lost: "bg-gray-100 text-gray-800",
    default: "bg-[var(--color-primary)] text-[var(--color-primary-foreground)]",
    secondary: "bg-[var(--color-secondary)] text-[var(--color-secondary-foreground)]",
    destructive: "bg-[var(--color-destructive)] text-[var(--color-destructive-foreground)]",
};
export function Badge({ children, variant = "default", className = "", }) {
    return (_jsx("span", { className: [
            "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
            variantClasses[variant],
            className,
        ].join(" "), children: children }));
}
